import { ParamMap, Params } from '@angular/router';
import { IBase } from 'src/app/models';
import { MessageReceiver } from 'src/app/models/enums';
import { parseIdList, serializeIdList } from './filterUtils';

export interface IMessagesFilters {
  selectedClients: IBase[];
  selectedSenders: IBase[];
  selectedReceivers: IBase[];
}

export interface IMessagesPanelFilters extends IMessagesFilters {
  receiverType?: MessageReceiver;
  selectedExpeditionService?: IBase;
  selectedExpeditionRoute?: IBase;
}

export const MESSAGE_FILTER_KEYS = ['clients', 'senders', 'receivers'] as const;

export function serializeMessagesFilters(f: IMessagesFilters): Params {
  return {
    clients: serializeIdList(f.selectedClients),
    senders: serializeIdList(f.selectedSenders),
    receivers: serializeIdList(f.selectedReceivers),
  };
}

export function deserializeMessagesFilters(params: ParamMap): IMessagesFilters {
  return {
    selectedClients: parseIdList(params.get('clients')),
    selectedSenders: parseIdList(params.get('senders')),
    selectedReceivers: parseIdList(params.get('receivers')),
  };
}

export function parseMessagesFiltersFromStorage(json: string | null | undefined): IMessagesFilters | null {
  if (!json) return null;
  try {
    const f = JSON.parse(json);
    return {
      selectedClients: Array.isArray(f.selectedClients) ? f.selectedClients : [],
      selectedSenders: Array.isArray(f.selectedSenders) ? f.selectedSenders : [],
      // The messages filter modal stores receivers under a nested key for legacy reasons.
      selectedReceivers: Array.isArray(f.receivers?.selectedReceivers)
        ? f.receivers.selectedReceivers
        : (Array.isArray(f.selectedReceivers) ? f.selectedReceivers : []),
    };
  } catch {
    return null;
  }
}

export function parseMessagesPanelFiltersFromStorage(json: string | null | undefined): IMessagesPanelFilters | null {
  const filters = parseMessagesFiltersFromStorage(json);
  if (!filters) return null;
  try {
    const receivers = JSON.parse(json!).receivers;
    return {
      ...filters,
      receiverType: receivers?.selectedReceiver ?? undefined,
      selectedExpeditionService: receivers?.selectedExpeditionService ?? undefined,
      selectedExpeditionRoute: receivers?.selectedExpeditionRoute ?? undefined,
    };
  } catch {
    return filters;
  }
}

export function serializeMessagesPanelFiltersForStorage(f: IMessagesPanelFilters): string {
  return JSON.stringify({
    selectedClients: f.selectedClients,
    selectedSenders: f.selectedSenders,
    receivers: {
      selectedReceiver: f.receiverType,
      selectedExpeditionService: f.selectedExpeditionService,
      selectedExpeditionRoute: f.selectedExpeditionRoute,
      selectedReceivers: f.selectedReceivers,
    },
  });
}
